export function finitePercent(value) {
  if (value === null || value === undefined || typeof value === 'boolean' || String(value).trim() === '') return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

export function formatPercent(value) {
  const number = finitePercent(value)
  if (number === null) return '--'
  const rounded = Number(number.toFixed(2))
  return `${rounded >= 0 ? '+' : ''}${rounded.toFixed(2)}%`
}

export function performanceClass(value) {
  const number = finitePercent(value)
  return number === null || number === 0 ? 'performance-neutral' : number > 0 ? 'performance-up' : 'performance-down'
}

export function topicKlinePerformance(rows, today) {
  const latest = rows && rows.length ? rows[rows.length - 1] : null
  const result = { date: latest ? latest.trade_date : '', open: null, current: null }
  if (!latest || latest.trade_date !== today) return result
  const previous = finitePercent(latest.prev_close)
  if (previous === null || previous <= 0) return result
  const open = finitePercent(latest.open)
  const close = finitePercent(latest.close)
  result.open = open !== null && open > 0 ? (open / previous - 1) * 100 : null
  result.current = close !== null && close > 0 ? (close / previous - 1) * 100 : null
  return result
}
